import { useEffect, useRef } from "react";
import { API_BASE } from "@/lib/api";

/**
 * Subscribes to backend /stream/events SSE.
 * @param {(event: any) => void} onEvent - called for every parsed event
 * @param {string[]} eventTypes - types to subscribe to (e.g. ['execution.created'])
 */
export function useSSE(onEvent, eventTypes = []) {
  const cbRef = useRef(onEvent);
  useEffect(() => { cbRef.current = onEvent; }, [onEvent]);

  useEffect(() => {
    const token = localStorage.getItem("bwz_token");
    if (!token) return;
    let es;
    try {
      es = new EventSource(`${API_BASE}/stream/events?token=${encodeURIComponent(token)}`);
    } catch (e) {
      return;
    }

    const handle = (ev) => {
      try {
        const data = ev.data ? JSON.parse(ev.data) : {};
        cbRef.current({ type: ev.type, ...data });
      } catch {}
    };

    es.addEventListener("message", handle);
    eventTypes.forEach((t) => es.addEventListener(t, handle));
    es.onerror = () => { /* auto-reconnect by browser */ };

    return () => {
      try { es.close(); } catch {}
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventTypes.join(",")]);
}

export default useSSE;
